// extracted by mini-css-extract-plugin
export default {"footerContainer":"bottom-bar_footerContainer__WB4SG"};